import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import QRView from "./QRView";
import { getGridColumns, getQRSize } from "./ConstantLayout";

export default function PDFViewer({ pages, qrPerPage }) {
  // Calculate grid columns based on QR codes per page

  return (
    <Container id="pdf-container" style={{ padding: "0" }}>
      {pages.map((page, pageIndex) => (
        <Card
          key={pageIndex}
          className="mb-2"
          style={{
            aspectRatio: "1 / 1.414", // A4 aspect ratio
            maxWidth: "800px",
            margin: "0 auto",
            pageBreakAfter: "always",
          }}
        >
          <div className="text-center m-2 pb-2 border-bottom">
            <h2 className="text-xl fw-bold text-primary">Machine QR Codes</h2>
            <p className="text-sm text-muted">
              Page {pageIndex + 1} of {pages.length}
            </p>
          </div>
          <CardBody>
            <Row className="mb-4">
              {page.map((machine, index) => (
                <Col
                  key={machine.id}
                  xs={getGridColumns(qrPerPage, page.length)[index]} // Use updated function
                  style={{ minWidth: qrPerPage === 1 ? "400px" : 'auto' }}
                  className="d-flex justify-content-center align-items-center mb-4"
                >
                  <QRView machine={machine} size={getQRSize(qrPerPage)} />
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      ))}
    </Container>
  );
}
